export default "https://cdn-static.gokick.com/assets/27898be65df9afd7cb19e5714fb6a6df6232ba84/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";